import {ADD_TAG_CLASS_NAME, ROOT_CLASS_NAME, TAG_CLASS_NAME} from "./constants";
import {RemoveGroup} from "./remove-group";
import {RemoveTag} from "./remove-tag";
import {CreateTag} from "./create-tag";
import {EditProject} from "./edit-project";
import {RenameGroup} from "./rename-group";
import {CreateGroup} from "./create-group";
import {AddTag} from "./add-tag";
import {UpdateTag} from "./update-tag";
import {TagChange} from "./tag-change";

const tags = () => {
  const rootElement = document.querySelector(`.${ROOT_CLASS_NAME}`);
  const tagElements = document.querySelectorAll(`.${TAG_CLASS_NAME}`);
  const addTagButtonElement = document.querySelector(`.${ADD_TAG_CLASS_NAME}`);

  if (addTagButtonElement) {
    new AddTag(addTagButtonElement);
  }

  new RemoveTag();
  new UpdateTag();
  new TagChange();

  if (rootElement || tagElements.length > 0) {
    new CreateGroup(rootElement);
    new RemoveGroup();
    new CreateTag();
    new EditProject();
    new RenameGroup();
  }
};

export default tags;
